export default "__VITE_ASSET__Cy7kEfnfQ6HzVqnSUjDhgA__"